import { Record } from 'immutable'

const BudgetBalanceRecord = Record({
  accountNumber: '',
  amount: undefined,
  dimensionCode: '',
  dimensionValueCode: '',
  month: undefined,
  year: undefined,
  id: undefined,
})

export default BudgetBalanceRecord
